export const NAME = 'definitions';
export const LEVEL_ONE = 'DefinitionsComponentReducer';
